import { useState, useRef } from "react"
import { ShareListingModal } from "pagesV2/pro/Experiences/Home/ShareModal"

export const useShareModal = () => {
  const [modalProps, setModalProps] = useState({
    listingTitle: "",
    listingAddress: "",
    listingImage: "",
    listingLink: "",
    shareText: ""
  })
  const [visible, setVisible] = useState(false)
  const shareCallback = useRef(null)

  const showShare = (trip) => {
    if (!trip?.id) return

    const url = `${global.location.origin}/#/trips/${trip.id}`
    const text = `${trip.title}\n\n${trip.address}\n\n`
    const image = trip?.photos?.find?.((img) => img?.position === 0)

    setModalProps({
      listingTitle: trip.title || "",
      listingAddress: trip.address || "",
      listingImage: image?.preview_url || "",
      listingLink: url,
      shareText: text
    })
    setVisible(true)
  }

  const handleClose = () => {
    setVisible(false)
    shareCallback.current = null
  }

  return {
    showShare,
    modal: visible ? (
      <ShareListingModal
        {...modalProps}
        visible={visible}
        onClose={handleClose}
      />
    ) : null
  }
} 